import { render } from "./BgRefundAmount.vue?vue&type=template&id=35b71e65&scoped=true"
import script from "./BgRefundAmount.vue?vue&type=script&lang=js"
export * from "./BgRefundAmount.vue?vue&type=script&lang=js"

import "./BgRefundAmount.vue?vue&type=style&index=0&id=35b71e65&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-35b71e65"

export default script